import html5ImgUrl from '../../../images/about/skills/html5.svg';
import css3ImgUrl from '../../../images/about/skills/css3.svg';
import sassImgUrl from '../../../images/about/skills/sass.svg';
import jsImgUrl from '../../../images/about/skills/js.svg';
import jsonImgUrl from '../../../images/about/skills/json.svg';
import reactImgUrl from '../../../images/about/skills/react.svg';
import reduxImgUrl from '../../../images/about/skills/redux.svg';
import jqueryImgUrl from '../../../images/about/skills/jquery.svg';
// import jestImgUrl from '../../../images/about/skills/jest.svg';
import cImgUrl from '../../../images/about/skills/c.svg';
// import pythonImgUrl from '../../../images/about/skills/python.svg';
import muiImgUrl from '../../../images/about/skills/mui.svg';
import tailwindcssImgUrl from '../../../images/about/skills/tailwindcss.svg';
import bootstrapImgUrl from '../../../images/about/skills/bootstrap.svg';
import babelImgUrl from '../../../images/about/skills/babel.svg';
import eslintImgUrl from '../../../images/about/skills/eslint.svg';
import prettierImgUrl from '../../../images/about/skills/prettier.svg';
import webpackImgUrl from '../../../images/about/skills/webpack.svg';
import parcelImgUrl from '../../../images/about/skills/parcel.svg';
import gulpImgUrl from '../../../images/about/skills/gulp.svg';
import npmImgUrl from '../../../images/about/skills/npm.svg';
import yarnImgUrl from '../../../images/about/skills/yarn.svg';
import gitImgUrl from '../../../images/about/skills/git.svg';
import githubImgUrl from '../../../images/about/skills/github.svg';
import vscImgUrl from '../../../images/about/skills/vsc.svg';
import eclipseImgUrl from '../../../images/about/skills/eclipse.svg';
import codeblocksImgUrl from '../../../images/about/skills/codeblocks.svg';
import chromeImgUrl from '../../../images/about/skills/chrome.svg';
import firefoxImgUrl from '../../../images/about/skills/firefox.svg';
import notionImgUrl from '../../../images/about/skills/notion.svg';
import trelloImgUrl from '../../../images/about/skills/trello.svg';
import googleKeepImgUrl from '../../../images/about/skills/google-keep.svg';
import windowsImgUrl from '../../../images/about/skills/windows.svg';
import msOfficeImgUrl from '../../../images/about/skills/ms-office.svg';

// const skillsListInfo = [
//   {
//     title: 'HTML5',
//     pathName: 'html5',
//     imgUrl: html5ImgUrl,
//   },
//   { title: 'CSS3', pathName: 'css3', imgUrl: css3ImgUrl },
//   { title: 'Sass', pathName: 'sass', imgUrl: sassImgUrl },
//   { title: 'JavaScript', pathName: 'js', imgUrl: jsImgUrl },
//   { title: 'JSON', pathName: 'json', imgUrl: jsonImgUrl },
//   { title: 'React', pathName: 'react', imgUrl: reactImgUrl },
//   { title: 'Redux', pathName: 'redux', imgUrl: reduxImgUrl },
//   { title: 'Jquery', pathName: 'jquery', imgUrl: jqueryImgUrl },
//   { title: 'Jest', pathName: 'jest', imgUrl: jestImgUrl },
//   { title: 'C programming', pathName: 'c', imgUrl: cImgUrl },
//   { title: 'Python', pathName: 'python', imgUrl: pythonImgUrl },
//   { title: 'Material UI', pathName: 'mui', imgUrl: muiImgUrl },
//   { title: 'Tailwind-CSS', pathName: 'tailwindcss', imgUrl: tailwindcssImgUrl },
//   { title: 'Bootstrap', pathName: 'bootstrap', imgUrl: bootstrapImgUrl },
//   { title: 'Babel', pathName: 'babel', imgUrl: babelImgUrl },
//   { title: 'EsLint', pathName: 'eslint', imgUrl: eslintImgUrl },
//   { title: 'Prettier', pathName: 'prettier', imgUrl: prettierImgUrl },
//   { title: 'Webpack', pathName: 'webpack', imgUrl: webpackImgUrl },
//   { title: 'Parcel', pathName: 'parcel', imgUrl: parcelImgUrl },
//   { title: 'Gulp', pathName: 'gulp', imgUrl: gulpImgUrl },
//   { title: 'NPM', pathName: 'npm', imgUrl: npmImgUrl },
//   { title: 'Yarn', pathName: 'yarn', imgUrl: yarnImgUrl },
//   { title: 'Git', pathName: 'git', imgUrl: gitImgUrl },
//   { title: 'Github', pathName: 'github', imgUrl: githubImgUrl },
//   { title: 'visual Studio Code', pathName: 'vsc', imgUrl: vscImgUrl },
//   { title: 'Eclipse', pathName: 'eclipse', imgUrl: eclipseImgUrl },
//   { title: 'CodeBlocks', pathName: 'codeblocks', imgUrl: codeblocksImgUrl },
//   { title: 'Google Chrome', pathName: 'chrome', imgUrl: chromeImgUrl },
//   { title: 'FireFox', pathName: 'firefox', imgUrl: firefoxImgUrl },
//   { title: 'Notion', pathName: 'notion', imgUrl: notionImgUrl },
//   { title: 'Trello', pathName: 'trello', imgUrl: trelloImgUrl },
//   {
//     title: 'Google Keep',
//     pathName: 'google-keep',
//     imgUrl: googleKeepImgUrl,
//   },
//   { title: 'Windows OS', pathName: 'windows', imgUrl: windowsImgUrl },
//   {
//     title: 'Microsoft Office',
//     pathName: 'ms-office',
//     imgUrl: msOfficeImgUrl,
//   },
// ];

const skillsListInfo = [
	{
		title: 'HTML5',
		pathName: 'html5',
		imgUrl: html5ImgUrl,
	},
	{ title: 'CSS3', pathName: 'css3', imgUrl: css3ImgUrl },
	{ title: 'Sass', pathName: 'sass', imgUrl: sassImgUrl },
	{ title: 'JavaScript', pathName: 'js', imgUrl: jsImgUrl },
	{ title: 'JSON', pathName: 'json', imgUrl: jsonImgUrl },
	{ title: 'React', pathName: 'react', imgUrl: reactImgUrl },
	{ title: 'Redux', pathName: 'redux', imgUrl: reduxImgUrl },
	{ title: 'Jquery', pathName: 'jquery', imgUrl: jqueryImgUrl },
	// { title: 'Jest', pathName: 'jest', imgUrl: jestImgUrl },
	{ title: 'C programming', pathName: 'c', imgUrl: cImgUrl },
	// { title: 'Python', pathName: 'python', imgUrl: pythonImgUrl },
	{ title: 'Material UI', pathName: 'mui', imgUrl: muiImgUrl },
	{ title: 'Tailwind-CSS', pathName: 'tailwindcss', imgUrl: tailwindcssImgUrl },
	{ title: 'Bootstrap', pathName: 'bootstrap', imgUrl: bootstrapImgUrl },
	{ title: 'Babel', pathName: 'babel', imgUrl: babelImgUrl },
	{ title: 'EsLint', pathName: 'eslint', imgUrl: eslintImgUrl },
	{ title: 'Prettier', pathName: 'prettier', imgUrl: prettierImgUrl },
	{ title: 'Webpack', pathName: 'webpack', imgUrl: webpackImgUrl },
	{ title: 'Parcel', pathName: 'parcel', imgUrl: parcelImgUrl },
	{ title: 'Gulp', pathName: 'gulp', imgUrl: gulpImgUrl },
	{ title: 'NPM', pathName: 'npm', imgUrl: npmImgUrl },
	{ title: 'Yarn', pathName: 'yarn', imgUrl: yarnImgUrl },
	{ title: 'Git', pathName: 'git', imgUrl: gitImgUrl },
	{ title: 'Github', pathName: 'github', imgUrl: githubImgUrl },
	{ title: 'visual Studio Code', pathName: 'vsc', imgUrl: vscImgUrl },
	{ title: 'Eclipse', pathName: 'eclipse', imgUrl: eclipseImgUrl },
	{ title: 'CodeBlocks', pathName: 'codeblocks', imgUrl: codeblocksImgUrl },
	{ title: 'Google Chrome', pathName: 'chrome', imgUrl: chromeImgUrl },
	{ title: 'FireFox', pathName: 'firefox', imgUrl: firefoxImgUrl },
	{ title: 'Notion', pathName: 'notion', imgUrl: notionImgUrl },
	{ title: 'Trello', pathName: 'trello', imgUrl: trelloImgUrl },
	{
		title: 'Google Keep',
		pathName: 'google-keep',
		imgUrl: googleKeepImgUrl,
	},
	{ title: 'Windows OS', pathName: 'windows', imgUrl: windowsImgUrl },
	{
		title: 'Microsoft Office',
		pathName: 'ms-office',
		imgUrl: msOfficeImgUrl,
	},
];

export default skillsListInfo;
